import styled from 'styled-components'
import TextareaAutosize from '@mui/material/TextareaAutosize'

type Props = {
  spacingBottom: number
}

const ComponentStyled = styled.div<Props>`
  width: 100%;

  .input-label {
    margin-bottom: 5px;
  }

  .input-error {
    color: ${({ theme }) => theme.colors.red};
  }
`

export const CustomizedTextArea = styled(TextareaAutosize)`
  resize: none;
  width: 100%;
  font-family: 'Playfair Display';
  font-weight: 800;
  font-size: 24px;
  line-height: 29px;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
  outline: none;
  border: 0;
  background: ${({ theme }) => theme.colors.transparent};

  &::placeholder {
    color: ${({ theme }) => theme.colors.gray2};
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
    font-size: 20px;
    line-height: 24px;
  }
`

export default ComponentStyled
